import { InvoiceScansI } from '../interfaces/invoice_scans.interface'
import { InvoiceScansService } from '../services/invoice_scans.service'
import { GetInvoiceScanResponseT } from '../types/invoice_scans.types'
import { PretensionByNumResponseT } from '@/core/types/pretensions.types'

const invoiceScansService = new InvoiceScansService()

class InvoiceScansRealisation implements InvoiceScansI {
    getScan(invoice_number: string): Promise<GetInvoiceScanResponseT> {
        return invoiceScansService.getScan(invoice_number)
    }

    saveScan(invoice_number: string, file: File, fileType: number): Promise<void> {
        return invoiceScansService.saveScan(invoice_number, file, fileType)
    }

    getInfoByNum(invoiceNumber: string): Promise<PretensionByNumResponseT> {
        return invoiceScansService.getInfoByNum(invoiceNumber)
    }
}

export const invoice_scans = new InvoiceScansRealisation()
